import "./GarageDoorRepairInnerWest.module.css";
import Header from "@/reusable_sections/Header";
import Hero from "./sections/Hero";
import GarageHero from "./sections/GarageHero";
import GarageServices from "./sections/GarageServices";
import Partners from "./sections/Partners";
import GarageProcess from "./sections/GarageProcess";
import WhyUs from "./sections/WhyUs";
import Suburbs from "./sections/Suburbs";
import Testimonials from "./sections/Testimonials";
import GarageFaq from "./sections/GarageFaq";
import GarageCta from "./sections/GarageCta";
import CompanyFooter from "./sections/CompanyFooter";
export default function GarageDoorRepairInnerWestPage() {
  return <div>
      <Header />
      <Hero />
      <GarageHero />
      <GarageServices />
      <Partners />
      <GarageProcess />
      <WhyUs />
      <Suburbs />
      <Testimonials />
      <GarageFaq />
      <GarageCta />
      <CompanyFooter />
    </div>;
}